import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {JSX} from "react";
import {Navigate} from "react-router";
import {getDefaultLandingPage} from "../functions";
import {getGlobalContext} from "../hooks/getGlobalContext";
import {useUser} from "../hooks/useUser";
import {PublicRoutes, WelcomeScreens} from "../routes";

export default function NavigateToDefault(): JSX.Element {
	const globalContext = getGlobalContext();
	const customWelcome = globalContext.installation.configuration.ui.features["welcome"];
	const welcome = isNullOrEmpty(customWelcome) ? null : WelcomeScreens[customWelcome];
	const user = useUser();
	if (user.authStatus == "unauthorized") {
		if (welcome == null) {
			return <Navigate to={PublicRoutes.welcome}/>;
		}

		return <Navigate to={welcome.path}/>;
	}

	return <Navigate to={getDefaultLandingPage()}/>;
}
